import * as yup from 'yup';

import subscriptionEmailsValidation from '../../subscriptionEmailsValidation';

const schema = () =>
  yup.object().shape({
    emails: subscriptionEmailsValidation(),
    notes: yup.string().nullable(),
    autoRenew: yup
      .object()
      .shape({
        label: yup.string(),
        value: yup.string(),
      })
      .nullable(),
  });

export default schema;
